import './App.css';
import "./assets/js/script";
import Header from './components/Header/Header';
import Rent2Rent from './components/Rent2Rent/Rent2Rent';
import Experience from './components/Experience/Experience';
import Advantages from './components/Advantages/Advantages';
import HowItWorks from './components/HowItWorks/HowItWorks';
import HomeStaging from './components/HomeStaging/HomeStaging';
import CTA from './components/CTA/CTA';
import FAQ from './components/FAQ/FAQ';
import SocialProof from './components/SocialProof/SocialProof';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <Rent2Rent />
      <Experience />
      <Advantages />
      <HomeStaging />
      <HowItWorks />
      <CTA />
      <FAQ />
      <SocialProof />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
